<app-field-assignments-form [fieldAssignmentsForm]="configurationFormFileFields"
    (loadFromTemplateClicked)="openLoadFromTemplateDialog()" (saveAsTemplateClicked)="openSaveAsTemplateDialog()">
</app-field-assignments-form>
<app-file-fields-load-from-template-dialog (loadFromTemplate)="templateSelected($event)">
</app-file-fields-load-from-template-dialog>
<app-file-fields-save-as-template-dialog (saveAsTemplate)="saveAsTemplate($event)">
</app-file-fields-save-as-template-dialog>